import { useState, useEffect, useRef } from 'react';
import { supabase } from '../lib/supabase';
import { fmt$0 } from '../utils/formatters';
import InspectName from './InspectName';

export default function InvoiceDetailModal({invoiceId,onClose,ings,batches,mi,orgId,t,sb,sh,sd,mn,setInvoiceModalId,navigateToVendorExpenses,zIndex=40,nested=false,highlightInvoiceItemNum=null,highlightInvoiceLineIdx=null,highlightDescription=null}){
const[data,setData]=useState(null);
const[loading,setLoading]=useState(true);
const[viewTab,setViewTab]=useState('details');
const backdropRef=useRef(false);
const highlightRef=useRef(null);

useEffect(()=>{
  if(!invoiceId)return;
  (async()=>{
    setLoading(true);setData(null);setViewTab('details');
    const{data:inv}=await supabase.from('invoices').select('*').eq('id',invoiceId).limit(1);
    if(!inv?.[0]){setLoading(false);return;}
    const invoice=inv[0];
    const[{data:lines},{data:expRows}]=await Promise.all([
      supabase.from('invoice_line_items').select('*').eq('invoice_id',invoice.id).order('id'),
      supabase.from('categorized_expenses').select('amount,description,invoice_item_number,invoice_line_index').eq('source_invoice_id',invoice.id).eq('is_superseded',false)
    ]);
    const expArr=expRows||[];
    const expTotal=expArr.reduce((s,r)=>s+(r.amount||0),0);
    const hlSet=new Set();const claimed=new Set();
    for(const exp of expArr){
      if(exp.invoice_item_number){const idx=(lines||[]).findIndex((li,j)=>!claimed.has(j)&&li.item_number===exp.invoice_item_number);if(idx>=0){hlSet.add(idx);claimed.add(idx);continue;}}
      if(exp.invoice_line_index!=null){const idx=exp.invoice_line_index;if(!claimed.has(idx)&&idx<(lines||[]).length){hlSet.add(idx);claimed.add(idx);continue;}}
      if(exp.description){const dl=exp.description.toLowerCase();const idx=(lines||[]).findIndex((li,j)=>!claimed.has(j)&&li.description&&li.description.toLowerCase()===dl);if(idx>=0){hlSet.add(idx);claimed.add(idx);}}
    }
    let fileUrl=null;
    if(invoice.file_url){
      const{data:signedData}=await supabase.storage.from('invoices').createSignedUrl(invoice.file_url,3600);
      if(signedData?.signedUrl)fileUrl=signedData.signedUrl;
    }
    setData({invoice,lineItems:lines||[],fileUrl,expTotal,expCount:expArr.length,hlSet});
    setLoading(false);
  })();
},[invoiceId]);

useEffect(()=>{if(data&&highlightRef.current)setTimeout(()=>highlightRef.current?.scrollIntoView({behavior:'smooth',block:'center'}),100);},[data]);

return(
<div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.6)",zIndex,display:"flex",alignItems:"center",justifyContent:"center",padding:"2vh 2vw"}} onMouseDown={e=>{backdropRef.current=e.target===e.currentTarget;}} onMouseUp={e=>{if(e.target===e.currentTarget&&backdropRef.current)onClose();backdropRef.current=false;}}>
<div style={{background:t.cd,borderRadius:12,border:`1px solid ${t.bd}`,width:"90vw",height:"90vh",display:"flex",flexDirection:"column",padding:0}}>
{loading?<div style={{textAlign:"center",padding:40,color:t.td,flex:1,display:"flex",alignItems:"center",justifyContent:"center"}}>Loading invoice...</div>:!data?<div style={{textAlign:"center",padding:40,flex:1,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:12}}><div style={{color:t.td}}>Invoice not found</div><button onClick={onClose} style={{...sb,background:t.bl}}>Close</button></div>:<>
{/* Header */}
<div style={{display:"flex",alignItems:"center",padding:"14px 24px",borderBottom:`1px solid ${t.bd}`,flexShrink:0}}>
<div style={{flex:1,minWidth:0}}>
<div style={{fontSize:18,fontWeight:700}}>{nested?<span>{data.invoice.vendor}</span>:<InspectName type="vendor" item={data.invoice.vendor} orgId={orgId} t={t} onViewExpenses={navigateToVendorExpenses} setInvoiceModalId={setInvoiceModalId} style={{color:t.bl}}>{data.invoice.vendor}</InspectName>}</div>
<div style={{fontSize:12,color:t.td,marginTop:2}}>Invoice #{data.invoice.invoice_number||"—"} — {data.invoice.invoice_date||"—"}</div>
</div>
<div style={{display:"flex",alignItems:"center",gap:0,border:`1px solid ${t.bd}`,borderRadius:8,overflow:"hidden",flexShrink:0}}>
<button onClick={()=>setViewTab('details')} style={{...sb,background:viewTab==='details'?t.bl:'transparent',color:viewTab==='details'?'#fff':t.tm,borderRadius:0,padding:"7px 16px",fontSize:11,border:"none"}}>Details</button>
{data.fileUrl&&<button onClick={()=>setViewTab('pdf')} style={{...sb,background:viewTab==='pdf'?t.bl:'transparent',color:viewTab==='pdf'?'#fff':t.tm,borderRadius:0,padding:"7px 16px",fontSize:11,border:"none",borderLeft:`1px solid ${t.bd}`}}>View PDF</button>}
</div>
<div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"flex-end",gap:10}}>
<div style={{fontFamily:mn,fontSize:18,fontWeight:700,color:t.gn}}>${(data.invoice.grand_total||data.invoice.total||0).toLocaleString(undefined,{minimumFractionDigits:2})}</div>
<button onClick={onClose} style={{...sb,background:"transparent",color:t.tm,fontSize:18,padding:4}}>✕</button>
</div>
</div>

{/* Details tab */}
{viewTab==='details'&&<div style={{flex:1,overflow:"auto",padding:"16px 24px"}}>
{data.lineItems.length>0?<>
{data.expTotal>0&&<div style={{display:'flex',justifyContent:'flex-end',gap:16,marginBottom:12,fontSize:12,fontFamily:mn}}>
<span><span style={{fontWeight:600}}>COGS:</span> <span style={{color:t.gn,fontWeight:600}}>${fmt$0((data.invoice.grand_total||data.invoice.total||0)-data.expTotal)}</span></span>
<span><span style={{fontWeight:600}}>Other expenses on this invoice ({data.expCount} line{data.expCount!==1?'s':''}):</span> <span style={{color:t.yl,fontWeight:600}}>${fmt$0(data.expTotal)}</span></span>
</div>}
<div style={{fontSize:13,fontWeight:600,marginBottom:10}}>{data.lineItems.length} Line Items{(()=>{const pc=data.lineItems.filter(li=>li.price_changed);return pc.length>0?<span style={{color:t.yl,fontWeight:400}}> — {pc.length} price change{pc.length!==1?'s':''}</span>:'';})()}</div>
<table style={{width:"100%",borderCollapse:"collapse"}}>
<thead><tr style={{background:t.sf}}>{["Item #","Description","Qty","Unit","Case Price","Amount","Cost Cat","Match","Price Change"].map(h=><th key={h} style={{...sh,fontSize:9}}>{h}</th>)}</tr></thead>
<tbody>{data.lineItems.map((li,i)=>{
const matched=li.matched_ingredient_id?(ings||[]).find(x=>x.id===li.matched_ingredient_id):null;
const costCat=matched?.ec||null;
const pctChg=li.old_price>0?((li.new_price-li.old_price)/li.old_price*100):0;
const up=li.new_price>li.old_price;
const isHL=data.hlSet.has(i);
return(
<tr key={i} ref={isHL?highlightRef:null} style={{borderBottom:`1px solid ${t.bd}`,background:isHL?'rgba(59,130,246,0.12)':li.price_changed?"rgba(212,168,36,0.04)":"transparent",outline:isHL?`1px solid ${t.bl}`:'none'}}>
<td style={{...sd,fontSize:10,color:t.td,fontFamily:mn}}>{li.item_number||"—"}</td>
<td style={{...sd,fontSize:11,fontWeight:500}}>{li.description}</td>
<td style={{...sd,fontFamily:mn,fontSize:11}}>{li.qty_shipped}</td>
<td style={{...sd,fontSize:10}}>{li.unit||"—"}</td>
<td style={{...sd,fontFamily:mn,fontSize:11}}>${fmt$0(li.unit_price||0)}</td>
<td style={{...sd,fontFamily:mn,fontSize:11,fontWeight:600}}>${fmt$0(li.amount||0)}</td>
<td style={sd}>{costCat?<span style={{fontSize:8,padding:'1px 5px',borderRadius:3,background:costCat==='Food'||costCat==='Packaging'?'rgba(59,130,246,0.1)':'rgba(212,168,36,0.1)',color:costCat==='Food'||costCat==='Packaging'?t.bl:t.yl}}>{costCat}</span>:<span style={{fontSize:9,color:t.td}}>—</span>}</td>
<td style={{...sd,fontSize:10,color:matched?t.gn:t.td}}>{matched?matched.n:"—"}</td>
<td style={sd}>{li.price_changed?<div>
<span style={{fontFamily:mn,fontSize:10,color:t.td,textDecoration:"line-through"}}>${fmt$0(li.old_price||0)}</span>
<span style={{fontFamily:mn,fontSize:10}}> → </span>
<span style={{fontFamily:mn,fontSize:11,fontWeight:600,color:up?t.ac:t.gn}}>${fmt$0(li.new_price||0)}</span>
<div style={{fontSize:9,color:up?t.ac:t.gn,fontWeight:600}}>{up?"▲":"▼"} {Math.abs(pctChg).toFixed(1)}%</div>
</div>:<span style={{fontSize:10,color:t.td}}>—</span>}</td>
</tr>);})}</tbody>
</table>
</>:<div style={{textAlign:"center",padding:40,color:t.td}}>No line items extracted</div>}
</div>}

{/* PDF tab */}
{viewTab==='pdf'&&<>{data.fileUrl?<div style={{flex:1,minHeight:0,background:t.sf}}>
{data.fileUrl.includes('.pdf')?
<iframe src={data.fileUrl+'#toolbar=1&navpanes=0&view=FitH'} style={{width:"100%",height:"100%",border:"none"}}/>:
<div style={{width:"100%",height:"100%",overflow:"auto",padding:16,textAlign:"center"}}><img src={data.fileUrl} style={{maxWidth:"100%"}} alt="Invoice"/></div>}
</div>:<div style={{padding:"40px 24px",textAlign:"center",color:t.td}}>No invoice file available</div>}</>}
</>}
</div></div>);
}
